export default __webpack_public_path__ + "static/media/game_bg.2827a8b6.jpg";